export default __webpack_public_path__ + "static/media/Jnnce.4a5766b5.png";